<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text, vue/no-root-v-if -->
<script setup>
defineProps({
  show: { type: Boolean, default: false },
  message: {
    type: String,
    default: 'Acompanhe sua atividade para manter a agenda em dia.',
  },
  actionLabel: { type: String, default: 'Minha atividade' },
});

const emit = defineEmits(['action']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text, vue/no-root-v-if -->
  <div
    v-show="show"
    class="flex items-center justify-between gap-3 rounded-lais border border-lais-primary/20 bg-lais-primary-50 px-4 py-3 text-[13px] text-lais-text"
  >
    <span>{{ message }}</span>
    <button
      type="button"
      class="font-semibold text-lais-primary"
      @click="emit('action')"
    >
      {{ actionLabel }}
    </button>
  </div>
</template>
